/* eslint-disable */
class Brightcove {
  constructor() {}

  baseUrl = '/api/brightcove/videos';

  async getVideosByProductBrand(productBrand) {
    const url = `${this.baseUrl}?limit=100&q=product_brand:${productBrand}`;
    const response = await fetch(url, {
      crossDomain: true,
    });
    const data = await response.json();
    const { count, videos } = data;

    return (count > 0) ? videos : null; 
  }

  async getVideosByProductId(productId) {
    const url = `${this.baseUrl}?limit=100&q=product_id:${productId}`;
    const response = await fetch(url, {
      crossDomain: true,
    });

    const data = await response.json();
    const { count, videos } = data;

    return (count > 0) ? videos : null; 
  }

  async getVideosByTag(tagName) {
    const url = `${this.baseUrl}?limit=100&q=tags:${tagName}`;
    const response = await fetch(url, {
      crossDomain: true,
    });
    const data = await response.json();
    const { count, videos } = data;

    return (count > 0) ? videos : null; 
  }

  async getVideosByOMSID(omsid) {
    const url = `${this.baseUrl}?limit=100&q=omsid:${omsid}`;
    const response = await fetch(url, {
      crossDomain: true,
    });
    const data = await response.json();
    const { count, videos } = data;

    return (count > 0) ? videos : null; 
  }

  async getVideoByVideoId(videoId) {
    const url = `${this.baseUrl}?limit=100&q=id:${videoId}`;
    const response = await fetch(url, {
      crossDomain: true,
    });
    const data = await response.json();
    const { count, videos } = data;

    return (count > 0) ? videos : null; 
  }
}

export default Brightcove;
